import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-vorlage-detail-admin';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentVorlageDetailAdminEffects {

    IncidentVorlageDetailAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_VORLAGE_DETAIL_ADMIN),
        mergeMap((x: ac.GetIncidentVorlageDetailAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentVorlageDetailAdmin(x.id).pipe(
                map((result: any) => {
                    return new ac.GetIncidentVorlageDetailAdminErfolgreichAction(result, x.id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentVorlageDetailAdminFehlerAction(error, x.id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentVorlageQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentVorlageQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentVorlageQueryService);
        }
        return this.service;
    }
}
